import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProjectConfigurationBehaviorSubjectService {
  
  public changeOccured: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor() { 

  }

  inform(): void {
      this.changeOccured.next(null);
  }
}
